export default "/assets/markers/deliveries_off.png"